import { ICEn } from "@/components/Icon/ICLanguage/ICEn";
import { ICVi } from "@/components/Icon/ICLanguage/ICVi";

export const languageList = {
  Afrikaans: "af",
  Albanian: "sq",
  Arabic_Algeria: "ar-dz",
  Arabic_Bahrain: "ar-bh",
  Arabic_Egypt: "ar-eg",
  Arabic_Iraq: "ar-iq",
  Arabic_Jordan: "ar-jo",
  Arabic_Kuwait: "ar-kw",
  Arabic_Lebanon: "ar-lb",
  Arabic_Libya: "ar-ly",
  Arabic_Morocco: "ar-ma",
  Arabic_Oman: "ar-om",
  Arabic_Qatar: "ar-qa",
  Arabic_SaudiArabia: "ar-sa",
  Arabic_Syria: "ar-sy",
  Arabic_Tunisia: "ar-tn",
  Arabic_UAE: "ar-ae",
  Arabic_Yemen: "ar-ye",
  Basque: "eu",
  Belarusian: "be",
  Bulgarian: "bg",
  Catalan: "ca",
  Chinese_HongKong: "zh-hk",
  Chinese_PRC: "zh-cn",
  Chinese_Singapore: "zh-sg",
  Chinese_Taiwan: "zh-tw",
  Croatian: "hr",
  Czech: "cs",
  Danish: "da",
  Dutch_Belgium: "nl-be",
  Dutch_Standard: "nl",
  English: "en",
  English_Australia: "en-au",
  English_Belize: "en-bz",
  English_Canada: "en-ca",
  English_Ireland: "en-ie",
  English_Jamaica: "en-jm",
  English_NewZealand: "en-nz",
  English_SouthAfrica: "en-za",
  English_Trinidad: "en-tt",
  English_UnitedKingdom: "en-gb",
  English_UnitedStates: "en-us",
  Estonian: "et",
  Faeroese: "fo",
  Farsi: "fa",
  Finnish: "fi",
  French_Belgium: "fr-be",
  French_Canada: "fr-ca",
  French_Luxembourg: "fr-lu",
  French_Standard: "fr",
  French_Switzerland: "fr-ch",
  Gaelic_Scotland: "gd",
  German_Austria: "de-at",
  German_Liechtenstein: "de-li",
  German_Luxembourg: "de-lu",
  German_Standard: "de",
  German_Switzerland: "de-ch",
  Greek: "el",
  Hebrew: "he",
  Hindi: "hi",
  Hungarian: "hu",
  Icelandic: "is",
  Indonesian: "id",
  Irish: "ga",
  Italian_Standard: "it",
  Italian_Switzerland: "it-ch",
  Japanese: "ja",
  Korean: "ko",
  Korean_Johab: "ko",
  Kurdish: "ku",
  Latvian: "lv",
  Lithuanian: "lt",
  Macedonian_FYROM: "mk",
  Malayalam: "ml",
  Malaysian: "ms",
  Maltese: "mt",
  Norwegian: "no",
  Norwegian_Bokmal: "nb",
  Norwegian_Nynorsk: "nn",
  Polish: "pl",
  Portuguese_Brazil: "pt-br",
  Portuguese_Portugal: "pt",
  Punjabi: "pa",
  Rhaeto_Romanic: "rm",
  Romanian: "ro",
  Romanian_RepublicOfMoldova: "ro-md",
  Russian: "ru",
  Russian_RepublicOfMoldova: "ru-md",
  Serbian: "sr",
  Slovak: "sk",
  Slovenian: "sl",
  Sorbian: "sb",
  Spanish_Argentina: "es-ar",
  Spanish_Bolivia: "es-bo",
  Spanish_Chile: "es-cl",
  Spanish_Colombia: "es-co",
  Spanish_CostaRica: "es-cr",
  Spanish_DominicanRepublic: "es-do",
  Spanish_Ecuador: "es-ec",
  Spanish_ElSalvador: "es-sv",
  Spanish_Guatemala: "es-gt",
  Spanish_Honduras: "es-hn",
  Spanish_Mexico: "es-mx",
  Spanish_Nicaragua: "es-ni",
  Spanish_Panama: "es-pa",
  Spanish_Paraguay: "es-py",
  Spanish_Peru: "es-pe",
  Spanish_PuertoRico: "es-pr",
  Spanish_Spain: "es",
  Spanish_Uruguay: "es-uy",
  Spanish_Venezuela: "es-ve",
  Swedish: "sv",
  Swedish_Finland: "sv-fi",
  Thai: "th",
  Tsonga: "ts",
  Tswana: "tn",
  Turkish: "tr",
  Ukrainian: "ua",
  Urdu: "ur",
  Venda: "ve",
  Vietnamese: "vi",
  Welsh: "cy",
  Xhosa: "xh",
  Yiddish: "ji",
  Zulu: "zu",
};

export const contentLanguageOptions = [
  { label: "English", value: "en" },
  { label: "Việt Nam", value: "vi" },
];

export const languageOptions = [
  { label: "English", value: "en", iconSvg: <ICEn /> },
  { label: "Việt Nam", value: "vi", iconSvg: <ICVi /> },
];
